import { inject, Injectable } from '@angular/core';
import { MobileNotificationComponent } from '@shared/ui';
import { NzModalService } from 'ng-zorro-antd/modal';

@Injectable({
  providedIn: 'root'
})
export class DeviceDetectionService {
  private readonly modalService = inject(NzModalService);

  detectMobileDevice(): void {
    const userAgent = navigator.userAgent || '';
    const mobileRegex = /iPhone|Android.*Mobile|Windows Phone/i;

    if (mobileRegex.test(userAgent)) {
      this.createComponentModal();
    }
  }

  private createComponentModal(): void {
    this.modalService.create<MobileNotificationComponent>({
      nzContent: MobileNotificationComponent,
      nzClosable: false,
      nzMaskClosable: false,
      nzFooter: null,
      nzTitle: null,
      nzWidth: '100vw',
      nzStyle: { top: '0', padding: '0' },
      nzBodyStyle: { padding: '0' },
      nzWrapClassName: 'full-screen-modal'
    });
  }
}
